module.exports = __webpack_public_path__ + "img/blue-caret-down.1412515a.svg";